export default __webpack_public_path__ + "static/media/techStack.616f4c2f.png";